import React, { useState, useEffect } from "react";
import { FaEye } from "react-icons/fa";
import QRCode from "qrcode.react"; // Import QR code library
import { IoIosRefresh } from "react-icons/io";
import { saveAs } from "file-saver";
import { ImCross } from "react-icons/im";
import { GoDownload } from "react-icons/go";
import dayjs from "dayjs";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Modal from "react-modal"; // Import react-modal for handling modals
import { toast } from "react-toastify";
import LoadingSpinner from "../components/LoadingSpinner";
import { sessionTimeoutManager } from "../utils/sessionTimeoutManager";
import TopUp from "./Topup"; // Import the Plan component
import { IoMdSearch } from "react-icons/io";
import { FaEdit } from "react-icons/fa";
import { FaCheck } from "react-icons/fa"; // Add this import for checkmark icon
import { FaUserPen } from "react-icons/fa6";
import { DateRange } from "react-date-range";
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
const PurchaseReport = () => {
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [qrModalOpen, setQrModalOpen] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [filter, setFilter] = useState(""); // State to manage dropdown filter
  const apiUrl = process.env.REACT_APP_BASE_URL; // Use the environment variable
  const [userRole, setUserRole] = useState(null); // State for user role
  const navigate = useNavigate();
  const [modalIsOpen, setModalIsOpen] = useState(false); // State for modal visibility
  const [renewalConfirmation, setRenewalConfirmation] = useState(null); // To store renewal confirmation message

  //For renewal
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [renewalTime, setRenewalTime] = useState("");
  const [selectedSale, setSelectedSale] = useState(null);
  const [searchQuery, setSearchQuery] = useState(""); // Add this line

  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [pendingRenewal, setPendingRenewal] = useState(null); // { plan, month }
  // NEW: States for inline editing Partner Customer
  const [editingOrderId, setEditingOrderId] = useState(null);
  const [editValue, setEditValue] = useState("");



  const [newExpiryDate, setNewExpiryDate] = useState(null);
  const [renewalDataInfo, setRenewalDataInfo] = useState(null); // Store full renewal data
  const [renewalDataList, setRenewalDataList] = useState([]); // NEW: Store all renewal data from API
 const [range, setRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection"
    }
  ]);

  const [showPicker, setShowPicker] = useState(false);
  // Updated useEffect to fetch renewal data when modal opens
  useEffect(() => {
    const orderId = selectedPlan?.orderid || selectedPlan?.order_id;

    if (orderId && isModalOpen) {
      console.log("🔄 useEffect triggered for order ID:", orderId);
      console.log("📝 Selected plan object:", selectedPlan);

      fetchRenewalData(orderId).then((renewalData) => {
        console.log("🎯 fetchRenewalData completed with result:", renewalData);

        if (renewalData) {
          setRenewalDataInfo(renewalData);
          setNewExpiryDate(renewalData.newExpiryDate);
          console.log("✅ renewalDataInfo state updated to:", renewalData);
        } else {
          console.log("❌ No renewal data found or API call failed");
          setNewExpiryDate(null);
          setRenewalDataInfo(null);
        }
      });

      // Also fetch all renewal data for the modal
      fetchAllRenewalData();
    } else {
      console.log(
        "⏸️ No order ID available in selectedPlan or modal is closed",
      );
    }
  }, [selectedPlan, isModalOpen]);

  // NEW: Function to fetch all renewal data
  const fetchAllRenewalData = async () => {
    try {
      const partnerCode = localStorage.getItem("partnerCode");

      const payload = {
        partnerCode: partnerCode,
        pageSize: 5000,
        pageIndex: 1,
      };

      console.log("📤 Fetching all renewal data with payload:", payload);

      const response = await axios.post(
        "https://esimgo.clay.in/api/Renew/GetRenewData_New",
        payload,
        {
          headers: {
            accept: "*/*",
            "Content-Type": "application/json",
          },
        },
      );

      console.log("📦 Full API Response:", response.data);

      if (response.data.isSuccess) {
        setRenewalDataList(response.data.renewData || []);
        console.log("✅ Renewal data list updated:", response.data.renewData);
      } else {
        console.error("❌ API returned unsuccessful:", response.data.message);
        setRenewalDataList([]);
      }
    } catch (error) {
      if (error?.response?.status === 401 || error?.response?.status === 403) {
        sessionTimeoutManager.showSessionTimeout();
      }
      console.error("🚨 Failed to fetch all renewal data:", error);
      setRenewalDataList([]);
    }
  };

 const fetchAndExportData = async () => {
  try {
    setLoading(true);

    const token = localStorage.getItem("token");
    const partnerCode = localStorage.getItem("partnerCode");

    if (!token) {
      toast.error("No token found. Please log in.");
      setLoading(false);
      return;
    }

    // ✅ Format dates for API
    const formattedFromDate = dayjs(range[0].startDate).format("YYYY-MM-DD");
    const formattedToDate = dayjs(range[0].endDate).format("YYYY-MM-DD");

    const payload = {
      flag: 4,
      fromdate: formattedFromDate,  // ✅ Formatted date
      todate: formattedToDate,       // ✅ Formatted date
      partnerCode: partnerCode,
    };

    console.log("Payload being sent to the API:", payload);

    const url = `${apiUrl}ESIM/Get_purchasereport_sourcewise`;

    const response = await axios.get(url, {
      params: payload,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const data = response.data.partnersale;

    if (!Array.isArray(data) || data.length === 0) {
      toast.error("No data found for the selected date range.");
      setLoading(false);
      return;
    }

    // Format activationCode for each item
    const formattedData = data.map((item) => {
      const activationCodeRaw = item.activationCode || "";
      let activationCodeAndroid = activationCodeRaw;
      let smdpIOS = "";
      let activationCodeIOS = "";

      if (activationCodeRaw.startsWith("LPA:1$")) {
        const parts = activationCodeRaw.split("$");
        if (parts.length === 3) {
          smdpIOS = parts[1];
          activationCodeIOS = parts[2];
        }
      }

      return {
        ...item,
        activationCodeAndroid,
        smdpIOS,
        activationCodeIOS,
      };
    });

    // Build CSV headers and rows
    const headers = Object.keys(formattedData[0]).join(",");
    const rows = formattedData
      .map((row) =>
        Object.values(row)
          .map((value) => `"${value}"`)
          .join(","),
      )
      .join("\n");

    const csvContent = headers + "\n" + rows;

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    
    // ✅ Format dates for filename (DD-MM-YYYY format)
    const fileFromDate = dayjs(range[0].startDate).format("DD-MM-YYYY");
    const fileToDate = dayjs(range[0].endDate).format("DD-MM-YYYY");
    
    const fileName = `PurchaseReport_${fileFromDate}_to_${fileToDate}.csv`;

    saveAs(blob, fileName);
    
    toast.success(`Downloaded ${data.length} records successfully!`);

    setLoading(false);
  } catch (error) {
    if (error?.response?.status === 401 || error?.response?.status === 403) {
      sessionTimeoutManager.showSessionTimeout();
    }
    console.error("Error fetching or exporting data:", error);
    toast.error("Error fetching or exporting data");
    setLoading(false);
  }
};

  const handleCreateTicket = async () => {
    const token = localStorage.getItem("token"); // Get token from localStorage
    const partnerCode = localStorage.getItem("partnerCode"); // Get partnercode from localStorage
    const ticketData = {
      iccid: selectedPlan?.order_id || "", // Use the actual order ID from the selected plan
      descrition: "I want to return this plan",
      partnercode: partnerCode,
      issuedepartment: 3,
      amount: 0,
    };

    try {
      const response = await axios.post(
        `${apiUrl}ESIM/CreateTicket`,
        ticketData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.status === 200 || response.status === 201) {
        toast(
          "Ticket raised successfully! Our team will get back to you soon.",
        );
        navigate("/YourTicket");
        console.log("Ticket Created:", response.data);
      } else {
        console.error("Unexpected response status:", response.status);
      }
    } catch (error) {
      if (error?.response?.status === 401 || error?.response?.status === 403) {
        sessionTimeoutManager.showSessionTimeout();
      }
      console.error("Error creating ticket:", error);
      toast.error("Error creating ticket. Please try again.");
    }
  };

  useEffect(() => {
    // Fetch user role from localStorage
    const role = localStorage.getItem("role");
    setUserRole(role);
  }, []);

  useEffect(() => {
    const fetchReportData = async () => {
      try {
        const token = localStorage.getItem("token");
        const partnerCode = localStorage.getItem("partnerCode");
        const response = await fetch(
          `${apiUrl}ESIM/Get_purchasereport_sourcewise?flag=3&partnercode=${partnerCode}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        if (response.status === 401 || response.status === 403) {
          sessionTimeoutManager.showSessionTimeout();
          throw new Error("Session expired or access forbidden");
        }

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await response.json();

        if (data.isSuccess) {
          setReportData(data.partnersale);
        } else {
          setError(data.message);
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchReportData();
  }, []);

  const openModal = (plan) => {
    setSelectedPlan(plan);
    setQrModalOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setIsModalOpen(false);
    setSelectedPlan(null);
    setRenewalTime("");
    setRenewalConfirmation(null);
    setRenewalDataList([]); // Clear renewal data list
    setRenewalDataInfo(null);
    setNewExpiryDate(null);
  };

  const handleTopup = (plan) => {
    localStorage.setItem("guid", plan.guid);
    localStorage.setItem("planid", plan.planid);
    localStorage.setItem("Iccid", plan.iccid);
    localStorage.setItem("vendorid", plan.supplier);
    setSelectedPlan(plan);

    if (plan.recharge === "1") {
      setIsModalOpen(true);
    } else {
      setModalIsOpen(true);
    }
  };

  const handleDownload = (lpacode) => {
    const qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?data=${lpacode}&size=200x200`;
    saveAs(qrCodeUrl, `QR_${lpacode}.png`);
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  const filteredReportData = (
    filter ? reportData.filter((sale) => sale.saletype === filter) : reportData
  ).filter((sale) => {
    if (!searchQuery) return true;

    const query = searchQuery.toLowerCase();
    return (
      sale.order_id?.toLowerCase().includes(query) ||
      sale.planname?.toLowerCase().includes(query) ||
      sale.iccid?.toLowerCase().includes(query)
    );
  });

  if (error) {
    return <p>Error: {error}</p>;
  }

  const handleViewDetails = (item) => {
    const details = {
      flag: 0,
      dataUsed: item.dataUsed,
      plan_Source: item.plan_source,
      dataallowance: item.dataallowanceMB,
      orderNumber: item.order_id,
      inventoryid: item.inventoryid,
      lpa: item.activationCode,
      dollar: item.dollar,
      price: item.purchaseamount,
      iccid: item.iccid,
      sellingamount: item.selling_price,
      subscriberID: item.subscriberID,
      cli: item.cli,
      purchasedate: "string",
      supplier: item.supplier,
      rc_id: 0,
      pagesno: 0,
      planid: "string",
      operatorid: "string",
      apn: "string",
      planfor: "string",
      planname: "string",
      esimNetProdcutCode: "string",
      internetdata: "string",
      dataunit: "string",
      validity: "string",
      validitytype: "string",
      minutes: "string",
      country: "string",
      region: "string",
      type: "string",
      travellertype: "string",
      dataallowancetype: "string",
      dataallowanceMonthly: "string",
      fairusagespolicy: "string",
      remarks: "string",
      buyingcost: "string",
      recharge: "string",
      topupname: "string",
      currency: "string",
      plancost: "string",
      priority: "string",
      userid: "string",
      roletype: "string",
      countryimage: "string",
      planimage: "string",
      planstatus: "string",
      addInfo: "string",
      ppartnerID: "string",
      minute: "string",
      plnclass: "string",
      fromdate: "string",
      todate: "string",
      topseler: "string",
      bestseler: "string",
      stockvalues: "string",
      internetbreakout: "string",
      internetbreakout_code: "string",
      order: 0,
      kyc: 0,
      operatortype: "string",
      minPlan: "string",
      perMBPrice: "string",
      throttle: "string",
      monthpluspln: "string",
      status: "string",
      operatorname: "string",
      operatorname2: "string",
      operatorlogo: "string",
      traveldates: "string",
      reference: "string",
      meta_title: "string",
      vendor_id: "string",
      activation_Date: "2025-03-17T09:38:25.021Z",
      activation_EndDate: "2025-03-17T09:38:25.021Z",
      email: "string",
      newICCID: "string",
      productCode: "string",
      paymentid: 0,
      kyc_type: "string",
      reason_Code: "string",
      esim_Status: "string",
      smdp: "string",
      cancelDate: "2025-03-17T09:38:25.021Z",
      subscrption_status: "string",
      dumyQRCode: "string",
      docStatus: 0,
      customerid: "string",
      guid: "string",
      travelDate: "2025-03-17T09:38:25.021Z",
      travelDateString: "string",
      buyingamount: "string",
      guidelineName: "string",
      guidelineId: 0,
      isDeleted: 0,
      durationType: 0,
      coverage: "string",
      esimPopResponce: "string",
      mcc: "string",
      mnc: "string",
      conditions: "string",
      features: "string",
      eventTypeID: "string",
      eventTypeName: "string",
      eventInfo: "string",
      isActive: "string",
      sdStatusID: "string",
      productID: "string",
      productName: "string",
      imei: "string",
      startDate: "string",
      createDate: "string",
      serviceDeviceID: "string",
      dataRemaining: 0,
      dataRemainingString: 0,
      imsi: "string",
      sms: 0,
      maxQty: 0,
      minQty: 0,
      bestValue: "string",
      gpAmt: 0,
      updateDate: "string",
      filePath: "string",
      ticketNumber: "string",
      simOperator: "string",
      tariff: 0,
      boltOns: 0,
    };

    const token = localStorage.getItem("token");

    if (!token) {
      toast.error("Unauthorized: No token found.");
      return;
    }

    fetch(`${apiUrl}ESIM/Get_data_uasage`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(details),
    })
      .then((response) => {
        if (response.status === 401 || response.status === 403) {
          sessionTimeoutManager.showSessionTimeout();
          throw new Error("Session expired or access forbidden");
        }
        return response.json();
      })
      .then((data) => {
        console.log("API response:", data);
        if (data.isSuccess) {
          toast.error(`${data.message}`);
        } else {
          toast.error(`Error: ${data.message}`);
        }
      })
      .catch((error) => {
        console.error("Error posting data:", error);
        toast.error(error.message || "An error occurred while posting data.");
      });
  };

  const requestRenewal = (plan, month, renewalItem = null) => {
    setPendingRenewal({ plan, month, renewalItem });
    setShowConfirmationModal(true);
  };

  const handleRenew = async () => {
    if (!pendingRenewal) return;

    const { plan, month, renewalItem } = pendingRenewal;
    const payload = {
      flag: "1",
      userAmount: renewalItem
        ? renewalItem.userAmount
        : (plan.purchaseamount * month).toString(),
      // ✅ CORRECT - Using logical OR chain for fallback
      orderID:
        renewalItem?.orderID ||
        plan?.order_id ||
        plan?.orderid ||
        selectedPlan?.order_id ||
        selectedPlan?.orderid ||
        "default-order-id",
      renewalDays: renewalItem ? renewalItem.renewalDays : month * 30,
    };

    console.log("📤 Renewal Payload:", payload);

    try {
      const response = await axios.post(`${apiUrl}Renew/InsertRenew`, payload, {
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
        },
      });
      alert(response.data?.message || "No message from server.");
      // alert("The eSIM renewal has been completed successfully.");
      closeModal();
    } catch (error) {
      const apiMessage = error.response?.data?.message;
      alert(`Renewal failed: ${apiMessage || error.message}`);
    } finally {
      setLoading(false);
      setShowConfirmationModal(false);
      setPendingRenewal(null);
    }
  };

  const updatecustomer = async (partnerCustomer, orderId) => {
    try {
      const token = localStorage.getItem("token");
      const partnerCode = localStorage.getItem("partnerCode");
      const response = await axios.post(
        `${apiUrl}ESIMGOAdmin/UpdatePartnerCustomer`,
        {
          partnerCode: partnerCode,
          orderId: orderId,
          partnerCustomer: partnerCustomer,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (response.data.isSuccess) {
        toast.success("Partner Customer updated successfully!");
        setReportData((prevData) =>
          prevData.map((sale) =>
            sale.order_id === orderId
              ? { ...sale, partnerCustomer: partnerCustomer }
              : sale,
          ),
        );
        setEditingOrderId(null);
        setEditValue("");
      } else {
        toast.error(
          response.data.message || "Failed to update Partner Customer",
        );
      }
    } catch (error) {
      console.error("Error updating partner customer:", error);
      toast.error("Error updating Partner Customer. Please try again.");
    }
  };

  const startEditing = (orderId, currentValue) => {
    setEditingOrderId(orderId);
    setEditValue(currentValue || "");
  };

  const saveEdit = (orderId) => {
    if (editValue.trim() !== "") {
      updatecustomer(editValue, orderId);
    } else {
      toast.warning("Please enter a valid Partner Customer name");
    }
  };

  const cancelEdit = () => {
    setEditingOrderId(null);
    setEditValue("");
  };

  // UPDATED: Function to fetch renewal data using new API
  const fetchRenewalData = async (orderId) => {
    try {
      console.log(`🔍 Fetching renewal data for order ID: ${orderId}`);

      const partnerCode = localStorage.getItem("partnerCode");

      const payload = {
        partnerCode: partnerCode,
        pageSize: 5000,
        pageIndex: 1,
      };

      console.log("📤 Sending POST request with payload:", payload);

      const response = await axios.post(
        "https://esimgo.clay.in/api/Renew/GetRenewData_New",
        payload,
        {
          headers: {
            accept: "*/*",
            "Content-Type": "application/json",
          },
        },
      );

      console.log("📦 Full API Response:", response.data);

      if (!response.data.isSuccess) {
        console.error("❌ API returned unsuccessful:", response.data.message);
        return null;
      }

      const renewalData = response.data.renewData || [];

      console.log(`📊 Total renewal records received: ${renewalData.length}`);

      // Find the matching renewal record by order ID
      const matchedRenewal = renewalData.find(
        (item) => item.orderID === orderId,
      );

      if (matchedRenewal) {
        console.log("✅ MATCH FOUND!");
        console.log("🎯 Matched renewal record:", matchedRenewal);
        return matchedRenewal;
      } else {
        console.log("❌ NO MATCH FOUND for order ID:", orderId);
        return null;
      }
    } catch (error) {
      if (error?.response?.status === 401 || error?.response?.status === 403) {
        sessionTimeoutManager.showSessionTimeout();
      }
      console.error("🚨 Failed to fetch renewal data:", error);
      return null;
    }
  };

  // Filter renewal data for current selected plan
  const filteredRenewalData = renewalDataList.filter(
    (item) => item.orderID === selectedPlan?.order_id,
  );

  if (loading) {
    return (
      <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <>
<div className="flex flex-col lg:flex-row lg:items-end lg:justify-end gap-4 mb-4 relative">

  {/* Date Range */}
  <div className="relative w-full sm:w-80">

    <label className="block mb-2 text-xs font-normal text-gray-700">
      Select Date Range:
    </label>

    {/* Input */}
    <div
      onClick={() => setShowPicker(!showPicker)}
      className="flex items-center justify-between border bg-[#3E436D] rounded-full px-5 py-3 text-[#d0e6e8] shadow-md cursor-pointer hover:shadow-lg transition"
    >
      <span className="text-sm">
        {range[0].startDate.toLocaleDateString()} -{" "}
        {range[0].endDate.toLocaleDateString()}
      </span>

      <span className="ml-3 text-lg">📅</span>
    </div>

    {/* Calendar */}
    {showPicker && (
      <div className="absolute right-0 mt-3 z-50 bg-white rounded-xl shadow-xl p-3 border w-[320px]">

        <DateRange
          ranges={range}
          onChange={(item) => setRange([item.selection])}
          moveRangeOnFirstSelection={false}
          editableDateInputs={true}
          months={1}
          direction="horizontal"
          showDateDisplay={true}
          className="w-full"
        />

      </div>
    )}

  </div>

  {/* Download Button */}
  <button
    onClick={fetchAndExportData}
    disabled={loading}
    className="rounded-full text-white font-semibold px-6 py-3 bg-[#3E436D] shadow-md hover:bg-[#4b4f7d] transition disabled:opacity-50"
  >
    {loading ? "Generating..." : "Download CSV"}
  </button>

</div>

      <div className="flex flex-col md:flex-row md:justify-between items-center p-2 bg-white space-y-4 md:space-y-0">
        <h2 className="text-3xl md:text-5xl font-bold w-full md:w-auto">
          Purchase History
        </h2>
        <div className="flex flex-col md:flex-row md:items-center w-full md:w-auto space-y-4 md:space-y-0 md:space-x-4">
          <div className="bg-[#3E436D] border-2 rounded-xl w-full md:w-96">
            <div className="relative">
              <input
                type="text"
                placeholder="Search Order ID Plan Name, ICCID"
                className="w-full rounded-2xl h-8 pl-10"
                value={searchQuery}
                onChange={handleSearch}
              />
              <div className="absolute inset-y-0 left-0 flex items-center pl-3">
                <IoMdSearch size={20} className="text-gray-500" />
              </div>
            </div>
          </div>

          <label
            htmlFor="filter"
            className="text-xl md:text-5xl font-bold mr-0 md:mr-2"
          >
            Sale Type:
          </label>
          <select
            id="filter"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            className="px-4 py-2 text-center border border-gray-700 rounded-md"
          >
            <option value="">All</option>
            <option value="API">API</option>
            <option value="Portal">Portal</option>
          </select>
        </div>
      </div>

      <table className="w-full bg-white rounded-md hidden  md:block ">
        <thead>
          <tr>
            <th className="px-6 py-3 text-center">Order ID</th>
            <th className="px-6 py-3 text-center">Purchase Date</th>
            <th className="px-6 py-3 text-center">Plan Name</th>
            {userRole === "Partner" && (
              <th className="px-6 py-3 text-center">Purchase Amount</th>
            )}
            <th className="px-6 py-3 text-center">Data Usage</th>
            <th className="px-6 py-3 text-center">Sale Type</th>
            <th className="px-6 py-3 text-center">Vendor ID</th>
            <th className="px-6 py-3 text-center">Top Up/Renew</th>
            <th className="px-6 py-3 text-center">Tag Name</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200">
          {filteredReportData.length === 0 ? (
            <tr>
              <td colSpan="6" className="text-center py-4">
                <p className="text-lg font-bold">No Active Packages</p>
              </td>
            </tr>
          ) : (
            filteredReportData.map((sale, index) => (
              <tr
                key={index}
                className="border-b hover:bg-gray-100 cursor-pointer relative"
                onClick={() => openModal(sale)}
              >
                <td className="px-6 py-4 text-center">{sale.order_id}</td>
                <td className="px-6 py-4 text-center">{sale.purchasedate}</td>
                <td className="px-6 py-4 text-center">UK 100 GB 30 Days</td>
                {userRole === "Partner" && (
                  <td className="px-6 py-4 text-center">
                    ${parseFloat(sale.purchaseamount).toFixed(2)}
                  </td>
                )}

                <td className="px-6 py-4 flex text-center">
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleViewDetails(sale);
                    }}
                    className="font-bold self-stretch shadow-[0px_2px_8px_rgba(92,_152,_140,_0.3)] rounded-xl bg-[#3E436D] hover:bg-[#144745] text-brand-white m-2 p-4"
                  >
                    <IoIosRefresh />
                  </button>
                </td>

                <td className="px-6 py-4 text-center">{sale.saletype}</td>
                <td className="px-6 py-4 text-center">112</td>

                <td className="px-6 py-4 text-center">
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleTopup(sale);
                    }}
                    className={`font-bold rounded-3xl p-4 text-white ${
                      sale.recharge === "1"
                        ? "text-[#3E436D] border-4 2px solid #3E436D"
                        : "bg-[#3E436D]"
                    }`}
                  >
                    {sale.recharge === "1" ? "Renew" : "Top_up"}
                  </button>
                </td>

                <td
                  className="px-6 py-4 text-center"
                  onClick={(e) => e.stopPropagation()}
                >
                  {editingOrderId === sale.order_id ? (
                    <div className="flex items-center justify-center gap-2">
                      <input
                        type="text"
                        value={editValue}
                        onChange={(e) => setEditValue(e.target.value)}
                        className="border-2 border-[#117575] rounded-lg px-2 py-1 w-32 focus:outline-none focus:border-[#3E436D]"
                        autoFocus
                        onKeyDown={(e) => {
                          if (e.key === "Enter") saveEdit(sale.order_id);
                          if (e.key === "Escape") cancelEdit();
                        }}
                        placeholder="Enter name"
                      />
                      <button
                        onClick={() => saveEdit(sale.order_id)}
                        className="text-green-600 hover:text-green-800 font-bold p-1 rounded transition-colors"
                        title="Save"
                      >
                        <FaCheck size={16} />
                      </button>
                      <button
                        onClick={cancelEdit}
                        className="text-red-600 hover:text-red-800 font-bold p-1 rounded transition-colors"
                        title="Cancel"
                      >
                        <ImCross size={14} />
                      </button>
                    </div>
                  ) : (
                    <div className="flex items-center justify-between gap-1 bg-[#f8fafc] rounded-xl border-2 border-[#ebeff5] p-2">
                      <span className="text-[#000000] max-w-[150px] sm:max-w-[120px] md:max-w-[100px] font-semibold overflow-hidden text-ellipsis whitespace-nowrap">
                        {sale.partnerCustomer || "Edit Name"}
                      </span>
                      <button
                        className="text-[#90a1b9] hover:text-[#3E436D] font-bold py-2 px-2 transition-colors text-shadow-lg ml-auto"
                        onClick={() =>
                          startEditing(sale.order_id, sale.partnerCustomer)
                        }
                        title="Edit Partner Customer"
                      >
                        <FaUserPen size={16} />
                      </button>
                    </div>
                  )}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {/* Mobile Card View – Only visible below md screens */}
      <div className="max-w-sm p-2 bg-gray-50 md:hidden">
        {filteredReportData.length > 0 ? (
          filteredReportData.map((sale) => (
            <div
              key={sale.order_id}
              className="bg-white rounded-3xl shadow-xl overflow-hidden  mb-6 cursor-pointer"
            >

              <div className="p-2 flex flex-col gap-10">
                {/* Order Header */}
                <div className="flex justify-between items-start">
                  <div>
                    <p className="text-xs text-gray-400 font-semibold">
                      ORDER ID
                    </p>
                    <p className="text-3xl font-bold text-[#3E436D]">
                      #{sale.order_id}
                    </p>
                    <p className="text-sm text-gray-500">{sale.planname}</p>
                  </div>

                  <span className="text-xs font-semibold bg-blue-100 text-blue-600 px-3 py-1 rounded-lg">
                    {sale.recharge === "1" ? "RENEW" : "TOP-UP"}
                  </span>
                </div>

                {/* Info Grid */}
                <div className="flex justify-between items-start">
                  <div>
                    <p className="text-xs text-gray-400 font-semibold">
                      Sale type
                    </p>

                    <span className="text-lg text-[#3E436D] font-semibold">
                      {sale.saletype}
                    </span>
                  </div>
                  <div>
                    <p className="text-xs text-gray-400 font-semibold">
                     Purchase Date
                    </p>

                    <span className="text-[#3E436D] font-semibold ">
                      {sale.purchasedate}
                    </span>
                  </div>
                </div>

                {/* Partner Customer */}
                <div className="flex items-center justify-between bg-gray-50 border rounded-xl p-2">
                  {editingOrderId === sale.order_id ? (
                    <div className="flex items-center gap-2 w-full">
                      <input
                        type="text"
                        value={editValue}
                        onChange={(e) => setEditValue(e.target.value)}
                        className="border rounded-lg px-2 py-1 w-full focus:outline-none"
                        onKeyDown={(e) => {
                          if (e.key === "Enter") saveEdit(sale.order_id);
                          if (e.key === "Escape") cancelEdit();
                        }}
                      />

                      <button
                        onClick={() => saveEdit(sale.order_id)}
                        className="text-green-600"
                      >
                        <FaCheck />
                      </button>

                      <button onClick={cancelEdit} className="text-red-600">
                        <ImCross />
                      </button>
                    </div>
                  ) : (
                    <>
                      <span className="text-sm font-semibold truncate">
                        {sale.partnerCustomer || "Add Tag Name"}
                      </span>

                      <button
                        onClick={() =>
                          startEditing(sale.order_id, sale.partnerCustomer)
                        }
                        className="text-gray-400 hover:text-[#3E436D]"
                      >
                        <FaUserPen />
                      </button>
                    </>
                  )}
                </div>

                {/* Buttons */}
                <div className="flex gap-3">
                   <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleTopup(sale);
                    }}
                    className={`flex-1 bg-[#3E436D] text-white font-semibold py-3 rounded-xl hover:bg-[#15294f] ${
                      sale.recharge === "1"
                        ? "text-[#ffffff] border-4 2px solid #3E436D"
                        : "bg-[#3E436D]"
                    }`}
                  >
                    {sale.recharge === "1" ? "Renew" : "Top_up"}
                  </button>

                  <button
                    onClick={() => handleViewDetails(sale)}
                    className="p-3 rounded-xl bg-[#3E436D] text-white"
                  >
                    <IoIosRefresh />
                  </button>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="text-center text-gray-400 py-10">
            No Plan for this condition
          </div>
        )}
      </div>

      {qrModalOpen && selectedPlan && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-900 bg-opacity-50 flex items-center justify-center overflow-y-auto">
          <div className="bg-white p-8 rounded-md flex flex-row relative  mt-36 ">
            {/* Left column */}
            <div className="flex flex-col items-start w-96">
              <div className="mb-4 p-4 w-full border-4 bg-slate-200 rounded-2xl">
                <span className="font-bold">Order ID:</span>{" "}
                <span className="ml-4">{selectedPlan?.order_id || "N/A"}</span>
              </div>
              <div className="mb-4 p-4 w-full border-4 bg-slate-200 rounded-2xl">
                <span className="font-bold">APN:</span>{" "}
                <span className="ml-4">{selectedPlan?.apn || "N/A"}</span>
              </div>
              <div className="mb-4 p-4 w-full border-4 bg-slate-200 rounded-2xl">
                <span className="font-bold">ICCID/MSISDN:</span>{" "}
                <span className="ml-4">{selectedPlan?.iccid || "N/A"}</span>
              </div>
              <div className="mb-4 p-4 w-full border-4 bg-slate-200 rounded-2xl">
                <span className="font-bold">SIMPIN:</span>{" "}
                <span className="ml-4">{selectedPlan?.simpin || "N/A"}</span>
              </div>

              <div className="mb-4 p-4 w-full border-4 bg-slate-200 rounded-2xl">
                <h1 className="font-bold">
                  For iOS Devices:
                  <span className="font-normal">
                    {" "}
                    Use Below SMDP & Activation code
                  </span>
                </h1>

                {(() => {
                  const fullCode = selectedPlan?.activationCode || "";
                  const parts = fullCode.split("$");
                  const smdp = parts.length >= 2 ? parts[1] : "N/A";
                  const activation = parts.length >= 3 ? parts[2] : "N/A";

                  return (
                    <div>
                      <div>
                        <span className="font-bold">SMDP:</span>
                        <span className="ml-4">{smdp}</span>
                      </div>
                      <div>
                        <span className="font-bold">Activation Code:</span>
                        <span className="ml-4">{activation}</span>
                      </div>
                    </div>
                  );
                })()}
              </div>
              <div className="mb-4 p-4 w-full border-4 bg-slate-200 rounded-2xl">
                <h1 className="font-bold">
                  For Andriod Devices:{" "}
                  <span className="font-normal">
                    Enter below Activation Code.
                  </span>{" "}
                </h1>{" "}
                {selectedPlan?.activationCode || "N/A"}
              </div>
              <div className="mb-4 p-2 w-full border-4 bg-slate-200 rounded-2xl">
                <div className="flex justify-between items-center mb-2">
                  <span className="font-semibold text-lg">Data usage:</span>
                  <div className="text-sm font-medium flex gap-2">
                    <span>
                      {selectedPlan?.dataUsed
                        ? `${Number(selectedPlan.dataUsed).toFixed(2)} MB`
                        : "N/A"}
                    </span>
                  </div>
                </div>
                <div className="flex justify-between items-center mb-2">
                  <span className="font-semibold text-lg">Data Remaining:</span>
                  <div className="text-sm font-medium flex gap-2">
                    <span>
                      {selectedPlan?.dataUsageRemaining
                        ? `${Number(selectedPlan.dataUsageRemaining).toFixed(
                            2,
                          )} MB`
                        : "N/A"}
                    </span>
                  </div>
                </div>
                <div className="w-full bg-gray-300 rounded-full h-4">
                  <div
                    className="bg-[#47a192] h-4 rounded-full"
                    style={{
                      width: `${
                        selectedPlan?.dataUsed && selectedPlan?.dataallowanceMB
                          ? (selectedPlan.dataUsed /
                              selectedPlan.dataallowanceMB) *
                            100
                          : 0
                      }%`,
                    }}
                  ></div>
                </div>
              </div>

              <div className="mb-4 p-4 w-full border-4 bg-[#c5f1f1] rounded-2xl">
                <span className="font-bold">How to Install ?</span>
                <a
                  href="https://www.airhubapp.com/info/esim-installation"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="ml-4 border-2 rounded-2xl hover:bg-blue-400 p-2 border-black"
                >
                  Step by Step Guide
                </a>
              </div>
            </div>

            {/* Right column */}
            <div className="flex flex-col items-center justify-center ml-8 hidden md:block ">
              <QRCode
                value={selectedPlan.activationCode}
                className="border-4 p-2 border-[#47a192]"
                size={200}
              />
              <button
                className="text-[#595959] flex items-center border border-black px-4 py-2 rounded mt-4"
                onClick={() => handleDownload(selectedPlan.activationCode)}
              >
                <GoDownload size={30} /> Download
              </button>
              <br></br>
              <button
                onClick={handleCreateTicket}
                className="self-stretch shadow-[0px_2px_8px_rgba(92,_152,_140,_0.3)] rounded-xl bg-brand-green-selected  hover:bg-[#144745] h-10 flex flex-row items-center justify-center p-2.5 box-border text-brand-white m-4"
              >
                Ticket For Dispute
              </button>
            </div>

            {/* Close button */}
            <ImCross
              size={30}
              onClick={() => setQrModalOpen(false)}
              className="cursor-pointer absolute top-2 right-2"
            />
          </div>
        </div>
      )}

      {/* Top Up Modal */}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          },
          content: {
            width: "80%",
            height: "90%",
            margin: "auto",
            padding: "0px",
            borderRadius: "8px",
          },
        }}
      >
        <div className="absolute top-4 right-5 flex justify-center items-center">
          <button onClick={closeModal} className="text-black">
            <ImCross size={20} />
          </button>
        </div>
        {selectedPlan && <TopUp plan={selectedPlan} closeModal={closeModal} />}
      </Modal>

      {/* UPDATED: Subscription Renewal Modal with New API Data */}
      {isModalOpen && selectedPlan && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-lg w-11/12 md:w-3/4 h-5/6 relative shadow-lg flex flex-col overflow-y-auto">
            {/* Modal Title */}
            <h1 className="text-2xl md:text-3xl font-bold mb-4 text-center text-gray-900">
              Selected Order ID : {selectedPlan.order_id}
            </h1>

            {/* Close Button */}
            <button
              onClick={closeModal}
              className="absolute top-4 right-4 p-2 text-gray-600 hover:text-gray-800 transition"
            >
              <ImCross size={20} />
            </button>

            {/* Renewal Plan Details */}
            <div className="flex flex-col items-center mb-4">
              {(() => {
                // Get renewal data for current order from API
                const currentRenewalData =
                  filteredRenewalData.length > 0
                    ? filteredRenewalData[0]
                    : null;

                // Get base selling cost from API (per month basis)
                const baseSellingCost = currentRenewalData
                  ? parseFloat(currentRenewalData.sellingCost) || 0
                  : parseFloat(selectedPlan.purchaseamount) || 0;

                // Calculate current expiry
                const currentExpiry = currentRenewalData?.purchaseDate
                  ? dayjs(currentRenewalData.purchaseDate).add(
                      currentRenewalData.renewalDays || 30,
                      "day",
                    )
                  : selectedPlan.purchasedate
                    ? dayjs(selectedPlan.purchasedate).add(30, "day")
                    : null;

                // Get selected duration from state (default to 1 month)
                const selectedMonths = parseInt(renewalTime) || 1;

                // Calculate new expiry based on selected duration
                const newExpiry = currentRenewalData?.newExpiryDate
                  ? dayjs(currentRenewalData.newExpiryDate).add(
                      (selectedMonths - 1) * 30,
                      "day",
                    )
                  : currentExpiry
                    ? currentExpiry.add(selectedMonths, "month")
                    : null;

                // Generate ALL renewal options for dropdown (1-12 months)
                const allRenewalOptions = Array.from(
                  { length: 12 },
                  (_, i) => ({
                    months: i + 1,
                    price: baseSellingCost * (i + 1),
                  }),
                );

                // Top picks options (only 3, 6, 9, 12 months)
                const topPicksOptions = [
                  { months: 3, price: baseSellingCost * 3 },
                  { months: 6, price: baseSellingCost * 6 },
                  { months: 9, price: baseSellingCost * 9 },
                  { months: 12, price: baseSellingCost * 12 },
                ];

                // Calculate per month price for display
                const getPerMonthPrice = (totalPrice, months) => {
                  return (totalPrice / months).toFixed(2);
                };

                return (
                  <>
                    {/* Expiry Information */}
                    <div className="w-full flex items-center bg-gray-50 p-1 rounded-lg mb-4 border-2">
                      <div className="text-green-600 font-bold ">
                        {" "}
                        {selectedPlan.order_id}:
                      </div>
                      <div className="flex justify-end w-full gap-6">
                        <p className="text-red-600 font-bold border-2 border-red-400 p-2 rounded-xl">
                          Current Expiry :
                          {currentExpiry
                            ? currentExpiry.format("DD-MM-YYYY")
                            : "N/A"}
                        </p>
                        <div className="font-bold text-green-600 bg-green-300 border-2 p-2 rounded-xl">
                          New Expiry :{" "}
                          {newExpiry ? newExpiry.format("DD-MM-YYYY") : "N/A"}
                        </div>
                      </div>
                    </div>

                    {/* Subscription Duration Selector (Dropdown) - Shows all 12 months */}
                    <div className="w-full mb-4">
                      <label className="block text-sm font-semibold text-gray-700">
                        Select Subscription Duration
                      </label>
                      <select
                        className="mt-2 block w-full px-4 py-2 border rounded-md shadow-sm text-gray-700"
                        value={renewalTime}
                        onChange={(e) => setRenewalTime(e.target.value)}
                      >
                        {allRenewalOptions.map((option) => (
                          <option key={option.months} value={option.months}>
                            {option.months} Month{option.months > 1 ? "s" : ""}{" "}
                            - ${option.price.toFixed(2)} ($
                            {getPerMonthPrice(option.price, option.months)}/mo)
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Renew Button for Selected Duration */}
                    <div className="w-full flex justify-end mt-6">
                      <button
                        onClick={() => {
                          const selectedOption = allRenewalOptions.find(
                            (opt) => opt.months === selectedMonths,
                          );
                          requestRenewal(selectedPlan, selectedMonths, {
                            ...currentRenewalData,
                            userAmount: selectedOption
                              ? selectedOption.price.toString()
                              : (baseSellingCost * selectedMonths).toString(),
                            renewalDays: selectedMonths * 30,
                          });
                        }}
                        className="w-fit bg-[#3E436D] hover:bg-[#144745] text-white py-3 px-6 rounded-lg font-bold text-lg transition-all shadow-md"
                      >
                        Renew for {selectedMonths} Month
                        {selectedMonths > 1 ? "s" : ""} - $
                        {(baseSellingCost * selectedMonths).toFixed(2)}
                      </button>
                    </div>

                    {/* Top Picks for Renewal - Only shows 3, 6, 9, 12 months */}
                    <h2 className="text-lg font-semibold text-gray-700 mb-4 mt-6">
                      Top Picks for Order ID: {selectedPlan.order_id}
                    </h2>
                    <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 w-full">
                      {topPicksOptions.map((plan, index) => {
                        const isSelected =
                          parseInt(renewalTime) === plan.months;
                        const calculatedNewExpiry = currentExpiry
                          ? currentExpiry.add(plan.months, "month")
                          : null;

                        return (
                          <div
                            key={index}
                            className={`p-4 rounded-lg shadow-md flex flex-col items-center text-center cursor-pointer transition-all ${
                              isSelected
                                ? "bg-[#3E436D] text-white border-2 border-[#3E436D]"
                                : "bg-gray-100 hover:bg-gray-200 border-2 border-transparent"
                            }`}
                            onClick={() =>
                              setRenewalTime(plan.months.toString())
                            }
                          >
                            <div
                              className={`text-xl font-semibold ${
                                isSelected ? "text-white" : "text-gray-900"
                              }`}
                            >
                              {plan.months} Month{plan.months > 1 ? "s" : ""}
                            </div>
                            <div
                              className={`text-sm ${
                                isSelected ? "text-gray-200" : "text-gray-500"
                              }`}
                            >
                              ${getPerMonthPrice(plan.price, plan.months)}/mo
                            </div>
                            <div
                              className={`text-xs mt-1 ${
                                isSelected ? "text-gray-300" : "text-gray-400"
                              }`}
                            >
                              Total: ${plan.price.toFixed(2)}
                            </div>
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                setRenewalTime(plan.months.toString());
                                requestRenewal(selectedPlan, plan.months, {
                                  ...currentRenewalData,
                                  userAmount: plan.price.toString(),
                                  renewalDays: plan.months * 30,
                                });
                              }}
                              className={`mt-4 py-2 px-4 rounded-md font-bold transition-all ${
                                isSelected
                                  ? "bg-white text-[#3E436D] hover:bg-gray-100"
                                  : "bg-[#3E436D] hover:bg-[#144745] text-white"
                              }`}
                            >
                              Renew
                            </button>
                          </div>
                        );
                      })}
                    </div>

                    {/* No API Data Warning */}
                    {!currentRenewalData && (
                      <p className="text-sm text-yellow-600 text-center mt-4">
                        ⚠️ No specific renewal data found for this order. Using
                        default pricing.
                      </p>
                    )}
                  </>
                );
              })()}
            </div>

            {/* Info Message */}
            {renewalConfirmation && (
              <div className="mt-4 text-center text-green-600 font-semibold">
                <p>{renewalConfirmation.message}</p>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Confirmation Modal */}
      {showConfirmationModal && pendingRenewal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full">
            <h1 className="text-[2rem] font-bold text-center mb-6 text-gray-800">
              Confirm Renewal
            </h1>

            <p className="text-center mb-2 text-5xl">
              Please confirm if your eSIM needs renewal for:
            </p>

            <div className="text-center font-semibold mb-6">
              <span className="text-brand-green-selected">
                {pendingRenewal.month} Month
                {pendingRenewal.month > 1 ? "s" : ""} -&nbsp; $
                {parseFloat(
                  pendingRenewal.plan.purchaseamount * pendingRenewal.month,
                ).toFixed(2)}
              </span>
            </div>

            <div className="flex justify-around mt-4">
              <button
                onClick={handleRenew}
                className="font-bold self-stretch shadow-md p-4 rounded-xl bg-[#3E436D] hover:bg-[#144745] text-brand-white "
              >
                Renew
              </button>
              <button
                onClick={() => {
                  setShowConfirmationModal(false);
                  setPendingRenewal(null);
                }}
                className="font-bold self-stretch shadow-md p-4 rounded-xl bg-[#111f1b] hover:bg-[#144745] text-brand-white "
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PurchaseReport;
